import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../hooks';
import { DrivesContext } from '../context/drives.context';

import DrivesPageStore from '../stores/DrivesPageStore';

/**
 * DrivesProvider - Provides DrivesPageStore to all child components
 * 
 * PERFORMANCE FIX:
 * - Removed 'observer' wrapper (was causing unnecessary re-renders)
 * - Added useMemo to create store only once (was recreating on every render)
 * - Store is now stable across re-renders
 */
export const DrivesProvider = ({ children }) => {
    const {
        drivesStore,
        foldersStore,
        documentsStore,
        filesStore,
        agentsStore,
        resourcesStore,
        usersStore
    } = useStore();

    // ✅ PERFORMANCE FIX: Create store only once, not on every render
    const store = useMemo(
        () => new DrivesPageStore({
            drivesStore,
            foldersStore,
            documentsStore,
            filesStore,
            agentsStore,
            resourcesStore,
            usersStore
        }),
        // Empty deps = only create on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <DrivesContext.Provider value={store}>
            {children}
        </DrivesContext.Provider>
    );
};
